import { createContext, PropsWithChildren, useContext } from 'react';
import { ApplicantsApi } from './api/applicants';
import { Applicant } from './types';

type ApplicantsContext = {
  addApplicant: (applicant: Applicant) => Promise<void>;
  withdraw: (email: string) => Promise<void>;
  keepAlive: (email: string, token: string) => Promise<void>;
};

const DEFAULT_CONTEXT: ApplicantsContext = {
  addApplicant: async (applicant) => {
    console.log('not adding', applicant);
  },
  withdraw: async (email) => {
    console.log('not withdrawing', email);
  },
  keepAlive: async (email: string, token: string) => {
    console.log('not keeping alive', { email, token });
  },
};
const context = createContext(DEFAULT_CONTEXT);
export const useApplicants = () => useContext(context);

type ProvideApplicantsProps = {
  applicantsApi: ApplicantsApi;
};

export const ApplicantsProvider = ({
  applicantsApi,
  children,
}: PropsWithChildren<ProvideApplicantsProps>) => {
  const applicants = {
    addApplicant: applicantsApi.addApplicant,
    withdraw: applicantsApi.withdraw,
    keepAlive: applicantsApi.keepAlive,
  };
  return <context.Provider value={applicants}>{children}</context.Provider>;
};
